window.timberSlider = window.timberSlider || {};

function isHidden(el) {
  return (el.offsetParent === null);
}

timberSlider.cacheSelectors = function () {
  timberSlider.cache = {
    // Home Page
    $slider: $('.flexslider')
  };
};

timberSlider.init = function () {
  timberSlider.cacheSelectors();
  timberSlider.sliders();
};

timberSlider.sliders = function () {
  var $slider = timberSlider.cache.$slider,
      sliderArgs = {
        animation: 'slide',
        animationSpeed: 500,
        animationLoop: true,
        pauseOnHover: true,
        controlNav: false,
        directionNav: true,
        keyboard: false,
        slideshow: true,
        slideshowSpeed: 5000,
        smoothHeight: true,
        fadeFirstSlide: false
      };

  if ($slider.length) {

    if ($slider.find('li').length === 1) {
      sliderArgs.slideshow = false;
      sliderArgs.slideshowSpeed = 0;
      sliderArgs.controlNav = false;
      sliderArgs.directionNav = false;
    }

    if (!$slider.data('flexslider') && !isHidden($slider[0])) {
      $slider.flexslider(sliderArgs);
    }
  }
};

// Initialize slider earlier so first slide appears faster
$(document).ready(function() {
  timberSlider.init();
});

$(window).on('resize', function(){
  if (timberSlider.cache && timberSlider.cache.$slider && timberSlider.cache.$slider.data('flexslider')) {
    timberSlider.cache.$slider.flexslider('resize');
  }
});